// extracted by mini-css-extract-plugin
export default {"section":"ExpressionOfInterestThankyouPageDetailsSection_section__be88J"};